"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.foundation_delay = void 0;
exports.foundation_delay = {
    delay: {
        delay_30ms: '30ms',
        delay_50ms: '50ms',
        delay_70ms: '70ms',
        delay_100ms: '100ms',
        delay_130ms: '130ms',
        delay_150ms: '150ms',
        delay_165ms: '165ms',
        delay_200ms: '200ms',
        delay_230ms: '230ms',
        delay_300ms: '300ms',
        delay_500ms: '500ms',
        delay_1s: '1s',
        delay_2s: '2s',
        delay_3s: '3s',
        delay_4s: '4s',
        delay_5s: '5s',
    },
};
//# sourceMappingURL=delay.js.map